import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { theme } from "./Theme";
import Step1 from "./pages/Step1";
import Step2 from "./pages/Step2";
import Step3 from "./pages/Step3";
import Step4 from "./pages/Step4";
import Step5 from "./pages/Step5";
import Booking from "./pages/Booking";
import Confirmation from "./pages/Confirmation";
import QuestionNaire from "./pages/QuestionNaire";
import Success from "./pages/Success";
import { Container } from "./components/Layout";
import Failed from "./pages/Failed";
import SuccessQuestion from "./pages/SuccessQuestion";
import { ToastProvider } from "./contexts/ToastProvider";

// function StepFlow() {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [userData, setUserData] = useState({
//     ethnicity: '',
//     weight: '',
//     height: '',
//     bmi: 0,
//     riskFactors: [],
//     contraindication: [],
//     booking: { date: null, time: null },
//     customerId: null,
//     name: '',
//     phone: '',
//     email: '',
//     note: '',
//   });
//   console.log(userData)
//   const handleNextStep = (data) => {
//     setUserData((prevState) => ({ ...prevState, ...data }));
//     setCurrentStep((prevStep) => prevStep + 1);
//   };

//   const handleBackStep = () => {
//     setCurrentStep((prevStep) => prevStep - 1);
//   };

//   const handleSkipStep3 = () => {
//     setCurrentStep(4); // Bỏ Step3, nhảy thẳng tới Step4
//   };

//   // const handleConfirmBooking = (customerId) => {
//   //   alert(`Booking confirmed!\n\nDate: ${userData.booking.date}\nTime: ${userData.booking.time}`);
//   //   setUserData((prevState) => ({ ...prevState, customerId }));
//   //   handleNextStep();
//   // };

//   return (
//     <Container>
//       {currentStep === 1 && <Step1 onNext={handleNextStep} />}
//       {/* {currentStep === 2 && <Step2 bmi={userData.bmi} ethnicity={userData.ethnicity} onNext={() => setCurrentStep(3)} onBack={handleBackStep} />} */}
//       {currentStep === 2 &&<Step2
//           bmi={userData.bmi}
//           ethnicity={userData.ethnicity}
//           onNext={() => setCurrentStep(3)}
//           onSkipStep3={handleSkipStep3}
//           onBack={handleBackStep}
//         />}
//       {currentStep === 3 && <Step3 onNext={(data) => handleNextStep({ riskFactors: data })} onBack={handleBackStep} />}
//       {currentStep === 4 && <Step4 bmi={userData.bmi} riskFactors={userData.riskFactors} onNext={() => setCurrentStep(5)} onBack={handleBackStep} />}
//       {currentStep === 5 && (<Step5 onNext={(data) => handleNextStep({ contraindication: data })} onBack={handleBackStep} />)}
//       {currentStep === 6 && <Booking onNext={(data) => handleNextStep({ booking: data })} onBack={handleBackStep} />}
//       {currentStep === 7 && <Confirmation booking={userData.booking} name={userData.name} phone={userData.phone} email={userData.email} note={userData.note} ethnicity={userData.ethnicity} weight={userData.weight} height={userData.height} bmi={userData.bmi} riskFactors={userData.riskFactors} contraindication={userData.contraindication} onBack={handleBackStep} />}
//     </Container>
//   );
// }

function StepFlow() {
  const [currentStep, setCurrentStep] = useState(1);
  const [userData, setUserData] = useState({
    ethnicity: "",
    weight: "",
    height: "",
    bmi: 0,
    riskFactors: [],
    contraindication: [],
    booking: { date: null, time: null },
    customerId: null,
    name: "",
    phone: "",
    email: "",
    note: "",
  });

  const handleNextStep = (data) => {
    setUserData((prevState) => ({ ...prevState, ...data }));
    setCurrentStep((prevStep) => prevStep + 1);
  };

  const handleBackStep = () => {
    if (currentStep === 4) {
      setCurrentStep(2);
    } else {
      setCurrentStep((prevStep) => prevStep - 1);
    }
  };

  const handleSkipStep3 = () => {
    setCurrentStep(4);
  };

  return (
    <Container>
      {currentStep === 1 && <Step1 onNext={handleNextStep} />}
      {currentStep === 2 && (
        <Step2
          bmi={userData.bmi}
          ethnicity={userData.ethnicity}
          onNext={() => setCurrentStep(3)}
          onSkipStep3={handleSkipStep3}
          onBack={handleBackStep}
        />
      )}
      {currentStep === 3 && (
        <Step3
          onNext={(data) => handleNextStep({ riskFactors: data })}
          onBack={handleBackStep}
        />
      )}
      {currentStep === 4 && (
        <Step4
          bmi={userData.bmi}
          riskFactors={userData.riskFactors}
          onNext={() => setCurrentStep(5)}
          onBack={handleBackStep}
        />
      )}
      {currentStep === 5 && (
        <Step5
          onNext={(data) => handleNextStep({ contraindication: data })}
          onBack={handleBackStep}
        />
      )}
      {currentStep === 6 && (
        <Booking
          onNext={(data) => handleNextStep({ booking: data })}
          onBack={handleBackStep}
        />
      )}
      {currentStep === 7 && (
        <Confirmation
          booking={userData.booking}
          name={userData.name}
          phone={userData.phone}
          email={userData.email}
          note={userData.note}
          ethnicity={userData.ethnicity}
          weight={userData.weight}
          height={userData.height}
          bmi={userData.bmi}
          riskFactors={userData.riskFactors}
          contraindication={userData.contraindication}
          onBack={handleBackStep}
        />
      )}
    </Container>
  );
}

function App() {
  return (
    <ToastProvider>
      <ThemeProvider theme={theme}>
        <Router basename={process.env.PUBLIC_URL}>
          <Routes>
            <Route path="/" element={<StepFlow />} />
            <Route path="/success/:id" element={<Success />} />
            <Route path="/fail" element={<Failed />} />
            <Route path="/questionnaire" element={<QuestionNaire />} />
            <Route path="/success-question" element={<SuccessQuestion />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </ToastProvider>
  );
}

export default App;
